/*eslint-disable react/no-set-state*/
import React, { PropTypes } from 'react';
import { Alert } from 'react-bootstrap';

export class ITAAlert extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      hidden: false
    };
    this.hideAlert = this.hideAlert.bind(this);
  }

  hideAlert() {
    this.setState({ hidden: true });
  }
  
  render() {
    return (
      <div className="ita-alert" hidden={this.state.hidden}>
        <Alert
          bsStyle={this.props.style}
          onDismiss={(this.props.style == "success" || this.props.style == "warning" || this.props.style == "danger")
            ? this.hideAlert : undefined}>
          {this.props.message}
        </Alert>
      </div>
    );
  }
}

ITAAlert.propTypes = {
  message: PropTypes.element.isRequired,
  style: PropTypes.string.isRequired
};


/** WEBPACK FOOTER **
 ** ./src/components/common/ITAAlert.js
 **/